import Vue from 'vue'
import Router from 'vue-router'
import PddRouters from './pddRouters'
import JdRouters from './jdRouters'
import DyRouters from './dyRouters'
import BaseSaleModeRuters from './baseModeRuters'
import store from '../store/index'
const Souhuo = () => import('@/views/souhuo/Souhuo.vue')
const My = () => import('@/views/my/My.vue')
const RemindSetting = () => import('@/views/my/RemindSetting')
const UserInfo = () => import('@/views/userInfo/UserInfo')
const AppUserInfo = () => import('@/views/userInfo/AppUserInfo')
const InReview = () => import('@/views/userInfo/InReview')
const ApplyForAccountCancellationStep1 = () => import('@/views/userInfo/ApplyForAccountCancellationStep1')
const ApplyForAccountCancellationStep2 = () => import('@/views/userInfo/ApplyForAccountCancellationStep2')
const Order = () => import('@/views/order/Order.vue')
const OrderSearchDetail = () => import('@/views/orderSearchDetail/orderSearchDetail')
const HadRefund = () => import('@/views/order/hadRefund/HadRefund.vue')
const Balance = () => import('@/views/balance/Balance.vue')
const WaitingRevertBalance = () => import('@/views/balance/WaitingRevertBalance.vue')
const BalanceDetail = () => import('@/views/balanceDetail/BalanceDetail.vue')
const BalanceWithdraw = () => import('@/views/balanceWithdraw/BalanceWithdraw.vue')
const WaitingForPayDetail = () => import('@/views/balanceWithdraw/WaitingForPayDetail.vue')
const BindBankCard = () => import('@/views/bindBankCard/BindBankCard')
const BindZFB = () => import('@/views/bindZFB/bindZFB')
const WithDrawLimitReason = () => import('@/views/balanceWithdraw/children/WithDrawLimitReason')
const Register = () => import('@/views/register/Register.vue')
const Sort = () => import('@/views/sort/sort.vue')
const SearchResult = () => import('@/views/search/searchResult/SearchResult.vue')
const SearchFeedback = () => import('@/views/search/searchfeedback/SearchFeedback.vue')
const OnePackage = () => import('@/views/onePackage/OnePackage.vue')
const PosterDetail = () => import('@/views/posterDetail/PosterDetail')
const GoodsDetail = () => import('@/views/goodsDetail/GoodsDetail')
const GoodsBlacklist = () => import('@/views/goodsBlacklist/GoodsBlacklist')
const CourseStep = () => import('@/views/courseStep/CourseStep')
const CourseStepOfDy = () => import('@/views/courseStep/CourseStepOfDy')
const NewProduct = () => import('@/views/newProduct/NewProduct')
const QualityZone = () => import('@/views/qualityZone/QualityZone')
const PartnerDetail = () => import('@/views/partner/partnerDetail/PartnerDetail')
const RecommendFriend = () => import('@/views/partner/recommendFriend/RecommendFriend')
const ExtractDetail = () => import('@/views/partner/extractDetail/ExtractDetail')
const OrderSubmit = () => import('@/views/orderSubmit/OrderSubmit')
const OrderSuccess = () => import('@/views/orderSuccess/OrderSuccess')
const RebateNote = () => import('@/views/rebateNote/RebateNote')
const InvitationEvaluation = () => import('@/views/invitation/invitationEvaluation/InvitationEvaluation')
const InvitationSubmit = () => import('@/views/invitation/invitationSubmit/InvitationSubmit')
const PresellGood = () => import('@/views/presellGood//PresellGood')
const ShareByImg = () => import('@/views/shareByImg/ShareByImg')
const StepOne = () => import('@/views/purchaseProcess/commonMode/tb/stepOne')
const StepTwo = () => import('@/views/purchaseProcess/commonMode/tb/stepTwo')
const StepThree = () => import('@/views/purchaseProcess/commonMode/tb/stepThree')
const CollarCartCenter = () => import('@/views/zeroBuy/collarCartCenter/CollarCartCenter')
const FreeCardDetail = () => import('@/views/zeroBuy/freeCardDetail/FreeCardDetail')
// const FreeRule = () => import('@/views/zeroBuy/freeRule/FreeRule')
// const AttendPage = () => import('@/views/zeroBuy/attendPage/AttendPage')
const ZeroBuyMain = () => import('@/views/zeroBuy/zeroBuyMain/ZeroBuyMain')
const LuckyPackage = () => import('@/views/luckyPackage/LuckyPackage')
const UnSearchCenter = () => import('@/views/unSearch/unSearchCenter/UnSearchCenter')
const UnSearchDetail = () => import('@/views/unSearch/unSearchDetail/UnSearchDetail')
const CarefullyChosenPage = () => import('@/views/unSearch/unSearchCenter/CarefullyChosenPage')
const CarefullyChosenDetail = () => import('@/views/unSearch/unSearchCenter/CarefullyChosenDetail')
const CashGiftGoodsDetail = () => import('@/views/unSearch/unSearchDetail/CashGiftGoodsDetail')
const DaTaoKeGoodsDetail = () => import('@/views/unSearch/unSearchDetail/DaTaoKeGoodsDetail')
const CouponCourse = () => import('@/views/unSearch/couponCourse/CouponCourse')
const LogisticsFeedback = () => import('@/views/feedback/LogisticsFeedback')
const DiffPeiceFeedback = () => import('@/views/feedback/DiffPeiceFeedback')
const CheckPeiceFeedback = () => import('@/views/feedback/CheckPeiceFeedback')
const Luckdraw = () => import('@/views/receivePrize/luckdraw/Luckdraw')
const ReceiveSubmit = () => import('@/views/receivePrize/receiveSubmit/ReceiveSubmit')
const OrderCheckout = () => import('@/views/receivePrize/orderCheckout/OrderCheckout')
const MemberUpgrade = () => import('@/views/member/memberUpgrade/MemberUpgrade')
const CollectionClip = () => import('@/views/collectionClip/CollectionClip')
const ComplaintPage = () => import('@/views/complaint/complaintPage/ComplaintPage')
const ComplaintDetail = () => import('@/views/complaint/complaintDetail/ComplaintDetail')
const QuestionOne = () => import('@/views/purchaseProcess/quesAndAnswers/QuestionOne')
const QuestionTwo = () => import('@/views/purchaseProcess/quesAndAnswers/QuestionTwo')
const QuestionThree = () => import('@/views/purchaseProcess/quesAndAnswers/QuestionThree')
const PlatformProtocol = () => import('@/views/platformProtocol/PlatformProtocol')
const ViolationPage = () => import('@/views/violationPage/Index/ViolationPage')
const GradeDesc = () => import('@/views/violationPage/GradeDesc/GradeDesc')
const GradeDetailed = () => import('@/views/violationPage/GradeDetailed/GradeDetailed')
const ViolationDetail = () => import('@/views/violationPage/ViolationDetail')
const RecommendRank = () => import('@/views/recommendRank/recommendRank/RecommendRank')
const RecommendHistory = () => import('@/views/recommendRank/recommendHistory/RecommendHistory')
const ReceiveFreeCard = () => import('@/views/receiveFreeCard/ReceiveFreeCard')
const NewcomerPage = () => import('@/views/newcomerPage/NewcomerPage')
const GoldSubsidyZone = () => import('@/views/goldSubsidyZone/index')
const UserAgreement = () => import('@/views/appPage/agreement/userAgreement')
const PrivacyAgreement = () => import('@/views/appPage/agreement/privacyAgreement')
const AccountCancellationNotice = () => import('@/views/appPage/agreement/accountCancellationNotice')
const AboutUs = () => import('@/views/appPage/aboutUs/aboutUs')
const HelpAndFeedback = () => import('@/views/helpAndFeedback/HelpAndFeedback')

Vue.use(Router)

const routes = [
  {
    path: '*',
    redirect: '/souhuo'
  },
  {
    path: '/',
    redirect: '/souhuo'
  },
  {
    path: '/souhuo',
    name: 'souhuo',
    component: Souhuo,
    meta: {
      keepAlive: true,
      title: '首页'
    }
  },
  // 收藏夹
  {
    name: 'collectionClip',
    path: '/collectionClip',
    component: CollectionClip,
    meta: {
      keepAlive: true,
      title: '收藏夹'
    }
  },
  {
    path: '/my',
    name: 'my',
    component: My,
    meta: {
      keepAlive: true,
      title: '我的'
    }
  },
  {
    path: '/remindSetting',
    name: 'remindSetting',
    component: RemindSetting,
    meta: {
      title: '推送设置'
    }
  },
  // 用户信息
  {
    path: '/userInfo',
    name: 'userInfo',
    component: UserInfo,
    meta: {
      title: '用户信息'
    }
  },
  // 账号和安全
  {
    path: '/appUserInfo',
    name: 'appUserInfo',
    component: AppUserInfo,
    meta: {
      title: '账号和安全'
    }
  },
  {
    path: '/inReview',
    name: 'inReview',
    component: InReview,
    meta: {
      title: '注销审核中'
    }
  },
  {
    path: '/applyForAccountCancellationStep1',
    name: 'applyForAccountCancellationStep1',
    component: ApplyForAccountCancellationStep1,
    meta: {
      title: '申请账号注销',
      keepAlive: true
    }
  },
  {
    path: '/applyForAccountCancellationStep2',
    name: 'applyForAccountCancellationStep2',
    component: ApplyForAccountCancellationStep2,
    meta: {
      title: '申请账号注销'
    }
  },
  {
    path: '/privacyAgreement',
    name: 'privacyAgreement',
    component: PrivacyAgreement,
    meta: {
      title: '《隐私协议》'
    }
  },
  {
    path: '/userAgreement',
    name: 'userAgreement',
    component: UserAgreement,
    meta: {
      title: '《用户协议》'
    }
  },
  {
    path: '/accountCancellationNotice',
    name: 'accountCancellationNotice',
    component: AccountCancellationNotice,
    meta: {
      title: '《账号注销须知页面》'
    }
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: AboutUs,
    meta: {
      title: '关于搜货精选'
    }
  },
  {
    path: '/helpAndFeedback',
    name: 'helpAndFeedback',
    component: HelpAndFeedback,
    meta: {
      title: '帮助与反馈'
    }
  },
  {
    path: '/order',
    name: 'order',
    component: Order,
    meta: {
      title: '订单列表',
      keepAlive: true
    }
  },
  {
    path: '/orderSearchDetail',
    name: 'orderSearchDetail',
    component: OrderSearchDetail,
    meta: {
      title: '订单搜索列表',
      keepAlive: true
    }
  },
  {
    path: '/hadRefund',
    name: 'hadRefund',
    component: HadRefund,
    meta: {
      title: '退款订单'
    }
  },
  // 余额提现
  {
    path: '/balanceWithdraw',
    name: 'balanceWithdraw',
    component: BalanceWithdraw,
    meta: {
      title: '余额提现'
    }
  },
  // 待扣除金额明细
  {
    path: '/waitingForPayDetail',
    name: 'waitingForPayDetail',
    component: WaitingForPayDetail,
    meta: {
      title: '待扣除金额明细'
    }
  },
  {
    path: '/bindCard',
    name: 'bindCard',
    component: BindBankCard,
    meta: {
      title: '添加银行卡'
    }
  },
  {
    path: '/bindZFB',
    name: 'bindZFB',
    component: BindZFB,
    meta: {
      title: '绑定支付宝信息'
    }
  },
  {
    path: '/withDrawLimitReason',
    name: 'withDrawLimitReason',
    component: WithDrawLimitReason,
    meta: {
      title: '提现限制'
    }
  },
  {
    path: '/balance',
    name: 'balance',
    component: Balance,
    meta: {
      title: '余额金额'
    }
  },
  {
    path: '/waitingRevertBalance',
    name: 'waitingRevertBalance',
    component: WaitingRevertBalance,
    meta: {
      title: '待返现金额'
    }
  },
  {
    path: '/balanceDetail',
    name: 'balanceDetail',
    component: BalanceDetail,
    meta: {
      title: '待返金额明细'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      title: '注册'
    }
  },
  {
    path: '/sort',
    name: 'sort',
    component: Sort,
    meta: {
      title: '全部分类'
    }
  },
  {
    path: '/searchResult',
    name: 'searchResult',
    component: SearchResult,
    meta: {
      keepAlive: true,
      title: '搜索结果'
    }
  },
  {
    path: '/searchFeedback',
    name: 'searchFeedback',
    component: SearchFeedback,
    meta: {
      title: '商品反馈'
    }
  },
  {
    path: '/onePackage',
    name: 'onePackage',
    component: OnePackage,
    meta: {
      keepAlive: true,
      title: '9.9包邮'
    }
  },
  {
    path: '/posterDetail',
    name: 'posterDetail',
    component: PosterDetail,
    meta: {
      title: '搜货是什么'
    }
  },
  {
    path: '/goodsDetail',
    name: 'goodsDetail',
    component: GoodsDetail,
    meta: {
      title: '商品详情'
    }
  },
  // 商品黑名单
  {
    path: '/goodsBlacklist',
    name: 'goodsBlacklist',
    component: GoodsBlacklist,
    meta: {
      title: '商品黑名单'
    }
  },
  {
    path: '/courseStepOfDy',
    name: 'courseStepOfDy',
    component: CourseStepOfDy,
    meta: {
      title: '如何搜索'
    }
  },
  {
    path: '/courseStep',
    name: 'courseStep',
    component: CourseStep,
    meta: {
      title: '如何搜索'
    }
  },
  {
    path: '/newProduct',
    name: 'newProduct',
    component: NewProduct,
    meta: {
      keepAlive: true,
      title: '新品首发'
    }
  },
  // 品质专区
  {
    path: '/qualityZone',
    name: 'qualityZone',
    component: QualityZone,
    meta: {
      keepAlive: true,
      title: '品质专区'
    }
  },
  {
    path: '/partnerDetail',
    name: 'partnerDetail',
    component: PartnerDetail,
    meta: {
      title: '搜货合伙人'
    }
  },
  {
    path: '/recommendFriend',
    name: 'recommendFriend',
    component: RecommendFriend,
    meta: {
      title: '推荐好友'
    }
  },
  {
    path: '/extractDetail',
    name: 'extractDetail',
    component: ExtractDetail,
    meta: {
      title: '合伙人收益'
    }
  },
  {
    path: '/orderSubmit',
    name: 'orderSubmit',
    component: OrderSubmit,
    meta: {
      title: '提交订单'
    }
  },
  {
    path: '/orderSuccess',
    name: 'orderSuccess',
    component: OrderSuccess,
    meta: {
      title: '提交成功'
    }
  },
  {
    path: '/rebateNote',
    name: 'rebateNote',
    component: RebateNote,
    meta: {
      title: '搜货教程'
    }
  },
  {
    path: '/invitationEvaluation',
    name: 'invitationEvaluation',
    component: InvitationEvaluation,
    meta: {
      title: '邀请评价'
    }
  },
  {
    path: '/invitationSubmit',
    name: 'invitationSubmit',
    component: InvitationSubmit,
    meta: {
      title: '提交评价'
    }
  },
  {
    path: '/presellGood',
    name: 'presellGood',
    component: PresellGood,
    meta: {
      title: '预售商品'
    }
  },
  {
    path: '/shareByImg',
    name: 'ShareByImg',
    component: ShareByImg,
    meta: {
      title: '邀请好友一起省钱'
    }
  },
  {
    path: '/stepOne',
    name: 'stepOne',
    component: StepOne,
    meta: {
      title: '第一步'
    }
  },
  {
    path: '/stepTwo',
    name: 'stepTwo',
    component: StepTwo,
    meta: {
      title: '第二步'
    }
  },
  {
    path: '/stepThree',
    name: 'stepThree',
    component: StepThree,
    meta: {
      title: '第三步'
    }
  },
  // 免单卡
  {
    path: '/collarCartCenter',
    name: 'collarCartCenter',
    component: CollarCartCenter,
    meta: {
      title: '免单卡'
    }
  },
  {
    path: '/freeCardDetail',
    name: 'freeCardDetail',
    component: FreeCardDetail,
    meta: {
      title: '免单卡明细'
    }
  },
  // {
  //   path: '/freeRule',
  //   name: 'freeRule',
  //   component: FreeRule,
  //   meta: {
  //     title: '抽取免单卡'
  //   }
  // },
  // {
  //   path: '/attendPage',
  //   name: 'attendPage',
  //   component: AttendPage,
  //   meta: {
  //     title: '已邀请好友'
  //   }
  // },
  {
    path: '/zeroBuyMain',
    name: 'zeroBuyMain',
    component: ZeroBuyMain,
    meta: {
      keepAlive: true,
      title: '0元专区'
    }
  },
  // 红包金额页
  {
    path: '/luckyPackage',
    name: 'luckyPackage',
    component: LuckyPackage,
    meta: {
      title: '领取红包'
    }
  },
  {
    path: '/goldSubsidyZone',
    name: 'goldSubsidyZone',
    component: GoldSubsidyZone,
    meta: {
      keepAlive: true,
      title: '金牌补贴专区'
    }
  },
  {
    path: '/unSearchCenter',
    name: 'unSearchCenter',
    component: UnSearchCenter,
    meta: {
      keepAlive: true,
      title: '补贴专区'
    }
  },
  {
    path: '/unSearchDetail',
    name: 'unSearchDetail',
    component: UnSearchDetail,
    meta: {
      title: '商品详情'
    }
  },
  {
    path: '/carefullyChosenPage',
    name: 'carefullyChosenPage',
    component: CarefullyChosenPage,
    meta: {
      title: '内容精选',
      keepAlive: true
    }
  },
  {
    path: '/carefullyChosenDetail',
    name: 'carefullyChosenDetail',
    component: CarefullyChosenDetail,
    meta: {
      title: '种草好物'
    }
  },
  {
    path: '/cashGiftGoodsDetail',
    name: 'cashGiftGoodsDetail',
    component: CashGiftGoodsDetail,
    meta: {
      title: '商品详情'
    }
  },
  {
    path: '/daTaoKeGoodsDetail',
    name: 'daTaoKeGoodsDetail',
    component: DaTaoKeGoodsDetail,
    meta: {
      title: '商品详情'
    }
  },
  // 领券教程
  {
    path: '/couponCourse',
    name: 'couponCourse',
    component: CouponCourse,
    meta: {
      title: '领券教程'
    }
  },
  // 物流反馈
  {
    path: '/logisticsFeedback',
    name: 'logisticsFeedback',
    component: LogisticsFeedback,
    meta: {
      title: '物流反馈'
    }
  },
  // 差价反馈
  {
    path: '/diffPeiceFeedback',
    name: 'diffPeiceFeedback',
    component: DiffPeiceFeedback,
    meta: {
      title: '差价反馈'
    }
  },
  // 查看差价反馈
  {
    path: '/checkPeiceFeedback',
    name: 'checkPeiceFeedback',
    component: CheckPeiceFeedback,
    meta: {
      title: '查看差价反馈'
    }
  },
  // 抽奖
  {
    path: '/luckdraw',
    name: 'luckdraw',
    component: Luckdraw,
    meta: {
      title: '抽奖'
    }
  },
  // 领取奖金
  {
    path: '/receiveSubmit',
    name: 'receiveSubmit',
    component: ReceiveSubmit,
    meta: {
      title: '领取奖金'
    }
  },
  {
    name: 'orderCheckout',
    path: '/orderCheckout',
    component: OrderCheckout,
    meta: {
      title: '提交评价订单'
    }
  },
  // 会员
  {
    name: 'memberUpgrade',
    path: '/memberUpgrade',
    component: MemberUpgrade,
    meta: {
      title: '会员详情'
    }
  },
  // 投诉
  {
    name: 'complaintPage',
    path: '/complaintPage',
    component: ComplaintPage,
    meta: {
      title: '投诉商品'
    }
  },
  // 投诉详情
  {
    name: 'complaintDetail',
    path: '/complaintDetail',
    component: ComplaintDetail,
    meta: {
      title: '投诉详情'
    }
  },
  // 问题回答
  {
    name: 'questionOne',
    path: '/questionOne',
    component: QuestionOne,
    meta: {
      title: '问题回答第一步'
    }
  },
  {
    name: 'questionTwo',
    path: '/questionTwo',
    component: QuestionTwo,
    meta: {
      title: '问题回答第二步'
    }
  },
  {
    name: 'questionThree',
    path: '/questionThree',
    component: QuestionThree,
    meta: {
      title: '问题回答第三步'
    }
  },
  // 平台协议
  {
    name: 'platformProtocol',
    path: '/platformProtocol',
    component: PlatformProtocol,
    meta: {
      title: '《平台协议》'
    }
  },
  // 待办与违规
  {
    name: 'violationPage',
    path: '/violationPage',
    component: ViolationPage,
    meta: {
      keepAlive: true,
      title: '待办与违规'
    }
  },
  // 行为分规则
  {
    name: 'gradeDesc',
    path: '/gradeDesc',
    component: GradeDesc,
    meta: {
      title: '行为分规则'
    }
  },
  // 违规扣分详情
  {
    name: 'violationDetail',
    path: '/violationDetail',
    component: ViolationDetail,
    meta: {
      title: '违规扣分详情'
    }
  },
  // 行为分明细
  {
    name: 'gradeDetailed',
    path: '/gradeDetailed',
    component: GradeDetailed,
    meta: {
      title: '行为分明细'
    }
  },
  // 推荐排行
  {
    name: 'recommendRank',
    path: '/recommendRank',
    component: RecommendRank,
    meta: {
      title: '推荐排行'
    }
  },
  // 推荐历史排行
  {
    name: 'recommendHistory',
    path: '/recommendHistory',
    component: RecommendHistory,
    meta: {
      title: '推荐历史排行'
    }
  },
  // 领取免单卡活动页
  {
    name: 'receiveFreeCard',
    path: '/receiveFreeCard',
    component: ReceiveFreeCard,
    meta: {
      title: '领取免单卡活动页'
    }
  },
  // 新人专享
  {
    name: 'newcomer',
    path: '/newcomer',
    component: NewcomerPage,
    meta: {
      keepAlive: true,
      title: '新人专区'
    }
  },
  ...PddRouters,
  ...JdRouters,
  ...DyRouters,
  ...BaseSaleModeRuters
]

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由修改浏览器标题
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  document.title = to.meta.title && to.meta ? to.meta.title : '搜货精选'
  store.commit('clearToken') // 取消请求
  next()
})

export default router
